
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire22ae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire22ae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7k9bU", function(module, exports) {

$parcel$export(module.exports, "Container", () => $555187cbafeb8690$export$42a852a2b6b56249);
$parcel$export(module.exports, "Text", () => $555187cbafeb8690$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "InfoCard", () => $555187cbafeb8690$export$2a4a2d730793fc2a);
$parcel$export(module.exports, "InfoGroup", () => $555187cbafeb8690$export$fe7150e29bf57509);
$parcel$export(module.exports, "ElementRenderer", () => $555187cbafeb8690$export$78640b07eb7f8d6c);
$parcel$export(module.exports, "SimpleElementRenderer", () => $555187cbafeb8690$export$6f627be93ceca953);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3S1uf = parcelRequire("3S1uf");

var $lerwN = parcelRequire("lerwN");

var $bETJ8 = parcelRequire("bETJ8");


var $gCqUr = parcelRequire("gCqUr");

var $137hX = parcelRequire("137hX");

var $9aZJ4 = parcelRequire("9aZJ4");

var $lGwH3 = parcelRequire("lGwH3");

var $6s3sp = parcelRequire("6s3sp");

var $4VZXd = parcelRequire("4VZXd");
function $555187cbafeb8690$export$42a852a2b6b56249({ active: active, fill: fill, full: full, padding: padding, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "access-container",
        active: active ? "" : null,
        fill: fill,
        full: full ? "" : null,
        padding: padding,
        children: children
    });
}
function $555187cbafeb8690$export$d7a54cba636a8cd6({ active: active, fill: fill, height: height }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "access-spacer",
        active: active ? "" : null,
        fill: fill,
        style: {
            height: height
        }
    });
}
function $555187cbafeb8690$export$5f1af8db9871e1d6({ active: active, fill: fill, color: color, size: size, align: align, paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, selectable: selectable, children: children }) {
    const breakpoint = /\[pdf=[^\[\]]+\]|\[ppt=[^\[\]]+\]|\[link=[^\[\]]+\]|\[[brlin]\]/g;
    const pdfBreakpoint = /\[pdf=([^\[\]]+)\]/g;
    const pptBreakpoint = /\[ppt=([^\[\]]+)\]/g;
    const linkBreakpoint = /\[link=([^\[\]]+)\]/g;
    const text = "[r][n]" + children;
    const format = text.match(breakpoint);
    const spans = text.split(breakpoint).map((e, i)=>[
            e,
            i == 0 ? "[r]" : format[i - 1]
        ]);
    let weight = "regular";
    let style = "normal";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "access-text",
        active: active ? "" : null,
        fill: fill,
        color: color,
        align: align,
        selectable: selectable ? "" : null,
        style: {
            fontSize: size,
            paddingTop: paddingTop,
            paddingBottom: paddingBottom,
            paddingLeft: paddingLeft ?? "32px",
            paddingRight: paddingRight ?? "32px"
        },
        children: spans.map((el, idx)=>{
            if (el[1].match(pdfBreakpoint)) {
                const url = el[1].replace(pdfBreakpoint, "$1");
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: url,
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($lerwN)))
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: `${weight} ${style}`,
                            children: el[0]
                        })
                    ]
                }, idx);
            } else if (el[1].match(pptBreakpoint)) {
                const url = el[1].replace(pptBreakpoint, "$1");
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: url,
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($bETJ8)))
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: `${weight} ${style}`,
                            children: el[0]
                        })
                    ]
                }, idx);
            } else if (el[1].match(linkBreakpoint)) {
                const url = el[1].replace(linkBreakpoint, "$1");
                return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: url,
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: `${weight} ${style}`,
                            children: el[0]
                        })
                    })
                }, idx);
            } else {
                switch(el[1]){
                    case "[b]":
                        weight = "bold";
                        break;
                    case "[l]":
                        weight = "light";
                        break;
                    case "[r]":
                        weight = "regular";
                        break;
                    case "[i]":
                        style = "italic";
                        break;
                    case "[n]":
                        style = "normal";
                        break;
                }
                return el[0] != "" && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: `${weight} ${style}`,
                    children: el[0]
                }, idx);
            }
        })
    });
}
function $555187cbafeb8690$export$3e431a229df88919({ active: active, fill: fill, srcs: srcs, columns: columns, gap: gap, width: width, align: align, paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight }) {
    srcs = Array.isArray(srcs) ? srcs : [
        srcs
    ];
    columns = `repeat(${columns ?? 1}, 1fr)`;
    const imgRef = srcs.map((_)=>(0, $acw62.useRef)(null));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "access-image",
        active: active ? "" : null,
        fill: fill,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            align: align,
            style: {
                width: width
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    paddingTop: paddingTop,
                    paddingBottom: paddingBottom,
                    paddingLeft: paddingLeft,
                    paddingRight: paddingRight,
                    gridTemplateColumns: columns,
                    gridGap: gap
                },
                children: srcs.map((src, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: src,
                        ref: imgRef[idx],
                        onLoad: (_)=>imgRef[idx].current.setAttribute("active", "")
                    }, idx))
            })
        })
    });
}
function $555187cbafeb8690$export$5a5d5b3e13f93711({ active: active, fill: fill, width: width, textConfig: textConfig, imageConfig: imageConfig }) {
    const text = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "text",
        style: {
            width: `calc(100% - ${width ?? "50%"})`
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$5f1af8db9871e1d6, {
            active: true,
            color: textConfig?.color,
            size: textConfig?.size,
            align: textConfig?.align,
            paddingTop: textConfig?.padding_top,
            paddingBottom: textConfig?.padding_bottom,
            paddingLeft: textConfig?.padding_left,
            paddingRight: textConfig?.padding_right,
            selectable: textConfig?.selectable,
            children: textConfig?.content
        })
    });
    const image = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "image",
        style: {
            width: width
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$3e431a229df88919, {
            active: true,
            srcs: imageConfig?.srcs,
            columns: imageConfig?.columns,
            gap: imageConfig?.gap,
            width: imageConfig?.width,
            align: imageConfig?.align,
            paddingTop: imageConfig?.padding_top,
            paddingBottom: imageConfig?.padding_bottom,
            paddingLeft: imageConfig?.padding_left,
            paddingRight: imageConfig?.padding_right
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "access-texted-image",
        active: active ? "" : null,
        fill: fill,
        children: imageConfig?.direction == "left" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                image,
                text
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                text,
                image
            ]
        })
    });
}
function $555187cbafeb8690$export$2a4a2d730793fc2a({ active: active, fill: fill, title: title, description: description, descriptionColor: descriptionColor, descriptionAlign: descriptionAlign }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        active: active ? "" : null,
        className: "access-infocard",
        fill: fill,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "title",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "description",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$5f1af8db9871e1d6, {
                    active: true,
                    color: descriptionColor,
                    align: descriptionAlign,
                    size: 18,
                    children: description
                })
            })
        ]
    });
}
function $555187cbafeb8690$export$fe7150e29bf57509({ active: active, fill: fill, title: title, contents: contents }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        active: active ? "" : null,
        className: "access-infogroup",
        fill: fill,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "title",
                children: title
            }),
            contents?.map((content, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$2a4a2d730793fc2a, {
                    active: true,
                    title: content.title,
                    description: content.description,
                    descriptionColor: content.color,
                    descriptionAlign: content.align
                }, idx))
        ]
    });
}
function $555187cbafeb8690$var$ProfessorInfo({ active: active, fill: fill }) {
    const lang = (0, $acw62.useContext)((0, $3S1uf.default));
    const [content, setContent] = (0, $acw62.useState)(null);
    active = content == null || !active ? null : "";
    (0, $acw62.useEffect)(()=>{
        var _;
        fetch(`/api/professor_details/professor_info.${lang}.json`).then((res)=>{
            if (res.ok) return res.json();
            throw new Error(`Fetch /api/professor_details/professor_info.${lang}.json failed`);
        }).then((json)=>setContent(json)).catch((e)=>console.error(e));
    }, [
        lang
    ]);
    const icon_data_table = [
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gCqUr))),
            text: content?.address
        },
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($137hX))),
            text: content?.phone
        },
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9aZJ4))),
            text: content?.fax
        },
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lGwH3))),
            text: content?.email,
            url: `mailto:${content?.email}`
        },
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6s3sp))),
            text: content?.website,
            url: content?.website
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        active: active,
        className: "access-professor-info",
        full: "",
        fill: fill,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "image",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$3e431a229df88919, {
                    active: true,
                    srcs: content?.img,
                    columns: 1,
                    width: "100%",
                    paddingLeft: "0"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                role: "text",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        role: "name_title",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                role: "name",
                                children: content?.name
                            }),
                            content?.titles?.map((title, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    role: "title",
                                    children: title
                                }, idx))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$5f1af8db9871e1d6, {
                        active: true,
                        align: "center",
                        size: 18,
                        children: content?.description
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            children: icon_data_table.map((data, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: data.icon
                                            })
                                        }, `icon${idx}`),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: data.url ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: data.url,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: data.text
                                                })
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: data.text
                                            })
                                        }, `text${idx}`)
                                    ]
                                }, `tr${idx}`))
                        })
                    })
                ]
            })
        ]
    });
}
function $555187cbafeb8690$export$78640b07eb7f8d6c({ active: active, full: full, contents: contents }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$42a852a2b6b56249, {
        active: active,
        full: full,
        children: contents?.map((content, idx)=>{
            const type = content.type;
            const config = content;
            switch(type){
                case "spacer":
                    return config?.sequence?.map((config, idx_)=>/*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$d7a54cba636a8cd6, {
                            active: true,
                            fill: config?.background,
                            height: config?.height
                        }, `${idx}-${idx_}`));
                case "text":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$5f1af8db9871e1d6, {
                        active: true,
                        fill: config?.background,
                        color: config?.color,
                        size: config?.size,
                        align: config?.align,
                        paddingTop: config?.padding_top,
                        paddingBottom: config?.padding_bottom,
                        paddingLeft: config?.padding_left,
                        paddingRight: config?.padding_right,
                        selectable: config?.selectable,
                        children: config?.content
                    }, idx);
                case "image":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$3e431a229df88919, {
                        active: true,
                        fill: config?.background,
                        srcs: config?.contents,
                        columns: config?.columns,
                        gap: config?.separation,
                        width: config?.width,
                        align: config?.align,
                        paddingTop: config?.padding_top,
                        paddingBottom: config?.padding_bottom,
                        paddingLeft: config?.padding_left,
                        paddingRight: config?.padding_right
                    }, idx);
                case "texted_image":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$5a5d5b3e13f93711, {
                        active: true,
                        fill: config?.background,
                        width: config?.image_width,
                        textConfig: config?.text,
                        imageConfig: config?.image
                    }, idx);
                case "professor_info":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$var$ProfessorInfo, {
                        active: true,
                        fill: config?.background
                    }, idx);
                case "professor_detail":
                    if (config?.contents == null || !Array.isArray(config?.contents) || config?.contents.length == 0) return null;
                    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4VZXd.ProfessorDetail), {
                        config: config
                    }, idx);
                case "professor_current_research":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4VZXd.ProfessorCurrentResearch), {
                        background: config?.background
                    }, idx);
                case "professor_biography":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4VZXd.ProfessorBiography), {
                        background: config?.background
                    }, idx);
                case "professor_honors":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4VZXd.ProfessorHonors), {
                        background: config?.background
                    }, idx);
                case "professor_publications":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4VZXd.ProfessorPublication), {
                        background: config?.background
                    }, idx);
                case "professor_service":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4VZXd.ProfessorService), {
                        background: config?.background
                    }, idx);
            }
        })
    });
}
function $555187cbafeb8690$export$6f627be93ceca953({ active: active, fill: fill, full: full, padding: padding, contents: contents }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$42a852a2b6b56249, {
        active: active,
        fill: fill,
        full: full,
        padding: padding,
        children: contents?.map((content, idx)=>{
            const type = content.type;
            const config = content;
            switch(type){
                case "spacer":
                    return config?.sequence?.map((config, idx_)=>/*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$d7a54cba636a8cd6, {
                            active: true,
                            fill: config?.background,
                            height: config?.height
                        }, `${idx}-${idx_}`));
                case "text":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$5f1af8db9871e1d6, {
                        active: true,
                        fill: config?.background,
                        color: config?.color,
                        size: config?.size,
                        align: config?.align,
                        paddingTop: config?.padding_top,
                        paddingBottom: config?.padding_bottom,
                        paddingLeft: config?.padding_left,
                        paddingRight: config?.padding_right,
                        selectable: config?.selectable,
                        children: config?.content
                    }, idx);
                case "image":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$3e431a229df88919, {
                        active: true,
                        fill: config?.background,
                        srcs: config?.contents,
                        columns: config?.columns,
                        gap: config?.separation,
                        width: config?.width,
                        align: config?.align,
                        paddingTop: config?.padding_top,
                        paddingBottom: config?.padding_bottom,
                        paddingLeft: config?.padding_left,
                        paddingRight: config?.padding_right
                    }, idx);
                case "texted_image":
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($555187cbafeb8690$export$5a5d5b3e13f93711, {
                        active: true,
                        fill: config?.background,
                        width: config?.image_width,
                        textConfig: config?.text,
                        imageConfig: config?.image
                    }, idx);
            }
        })
    });
}

});
parcelRegister("lerwN", function(module, exports) {
module.exports = import.meta.resolve("dUrpI");

});

parcelRegister("bETJ8", function(module, exports) {
module.exports = import.meta.resolve("iLaMU");

});

parcelRegister("gCqUr", function(module, exports) {
module.exports = import.meta.resolve("52O6m");

});

parcelRegister("137hX", function(module, exports) {
module.exports = import.meta.resolve("37pF2");

});

parcelRegister("9aZJ4", function(module, exports) {
module.exports = import.meta.resolve("bHciK");

});

parcelRegister("lGwH3", function(module, exports) {
module.exports = import.meta.resolve("hUvfd");

});

parcelRegister("6s3sp", function(module, exports) {
module.exports = import.meta.resolve("2Sv2z");

});

parcelRegister("4VZXd", function(module, exports) {

$parcel$export(module.exports, "ProfessorCurrentResearch", () => $397c8b1a60686856$export$c15df2d8b869fe4d);
$parcel$export(module.exports, "ProfessorBiography", () => $397c8b1a60686856$export$57ecca8ac58a4530);
$parcel$export(module.exports, "ProfessorHonors", () => $397c8b1a60686856$export$c98c3d1bc7c1ec35);
$parcel$export(module.exports, "ProfessorPublication", () => $397c8b1a60686856$export$60832fa9c80d3b5b);
$parcel$export(module.exports, "ProfessorService", () => $397c8b1a60686856$export$88277120dd767cf5);
$parcel$export(module.exports, "ProfessorDetail", () => $397c8b1a60686856$export$3c0074a3e47084e0);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3S1uf = parcelRequire("3S1uf");

var $7k9bU = parcelRequire("7k9bU");

function $397c8b1a60686856$var$ProfessorDetailTab({ tabNames: tabNames, currentTab: currentTab, onTabClick: onTabClick }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        active: "",
        className: "access-professor-detail-tab",
        children: tabNames.map((tabName, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                active: idx == currentTab ? '' : null,
                onClick: ()=>onTabClick(idx),
                children: tabName
            }, idx))
    });
}
function $397c8b1a60686856$export$c15df2d8b869fe4d({ background: background }) {
    const lang = (0, $acw62.useContext)((0, $3S1uf.default));
    const [content, setContent] = (0, $acw62.useState)(null);
    const active = content != null;
    (0, $acw62.useEffect)(()=>{
        fetch(`/api/professor_details/research_map.${lang}.json`).then((res)=>{
            if (res.ok) return res.json();
            throw new Error(`Fetch /api/professor_details/research_map.${lang}.json failed`);
        }).then((json)=>setContent(json)).catch((e)=>console.error(e));
    }, [
        lang
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7k9bU.SimpleElementRenderer), {
        active: active,
        fill: background,
        full: true,
        padding: "all",
        contents: content
    });
}
function $397c8b1a60686856$export$57ecca8ac58a4530({ background: background }) {
    const lang = (0, $acw62.useContext)((0, $3S1uf.default));
    const [content, setContent] = (0, $acw62.useState)(null);
    const active = content != null;
    (0, $acw62.useEffect)(()=>{
        fetch(`/api/professor_details/biography.${lang}.json`).then((res)=>{
            if (res.ok) return res.json();
            throw new Error(`Fetch /api/professor_details/biography.${lang}.json failed`);
        }).then((json)=>setContent(json)).catch((e)=>console.error(e));
    }, [
        lang
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7k9bU.SimpleElementRenderer), {
        active: active,
        fill: background,
        full: true,
        padding: "all",
        contents: content
    });
}
function $397c8b1a60686856$export$c98c3d1bc7c1ec35({ background: background }) {
    const lang = (0, $acw62.useContext)((0, $3S1uf.default));
    const [content, setContent] = (0, $acw62.useState)(null);
    const active = content != null;
    (0, $acw62.useEffect)(()=>{
        fetch(`/api/professor_details/honors.${lang}.json`).then((res)=>{
            if (res.ok) return res.json();
            throw new Error(`Fetch /api/professor_details/honors.${lang}.json failed`);
        }).then((json)=>setContent(json)).catch((e)=>console.error(e));
    }, [
        lang
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7k9bU.Container), {
        active: active,
        fill: background,
        full: true,
        padding: "horizontal",
        children: content?.map((honor, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7k9bU.InfoCard), {
                active: true,
                title: honor.title,
                description: honor.description,
                descriptionColor: "light",
                descriptionAlign: "center"
            }, idx))
    });
}
function $397c8b1a60686856$export$60832fa9c80d3b5b({ background: background }) {
    const lang = (0, $acw62.useContext)((0, $3S1uf.default));
    const [content, setContent] = (0, $acw62.useState)(null);
    const active = content != null;
    (0, $acw62.useEffect)(()=>{
        Promise.all([
            fetch(`/api/research/journals.json`),
            fetch(`/api/research/conferences.json`)
        ]).then((res)=>{
            if (res[0].ok && res[1].ok) return Promise.all([
                res[0].json(),
                res[1].json()
            ]);
            throw new Error(`Fetch /api/research/journals.json, /api/research/conferences.json failed`);
        }).then(([json_journal, json_conference])=>{
            let latest_journal_year = Math.max(...json_journal.map((y)=>parseInt(y.title)));
            let latest_conference_year = Math.max(...json_conference.map((y)=>parseInt(y.title)));
            let journals = json_journal.find((y)=>parseInt(y.title) == latest_journal_year).contents;
            let conferences = json_conference.find((y)=>parseInt(y.title) == latest_conference_year).contents;
            return [
                {
                    "title": `${latest_journal_year} - Journal`,
                    "contents": journals.slice(0, 5)
                },
                {
                    "title": `${latest_conference_year} - Conference`,
                    "contents": conferences.slice(0, 5)
                }
            ];
        }).then((json)=>setContent(json)).catch((e)=>console.error(e));
    }, [
        lang
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7k9bU.Container), {
        active: active,
        fill: background,
        full: true,
        padding: "all",
        children: content?.map((group, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7k9bU.InfoGroup), {
                active: true,
                title: group.title,
                contents: group.contents.map((publication)=>({
                        title: "",
                        description: publication.title + (publication.url != null ? `[pdf=${publication.url}]` : "")
                    })),
                descriptionAlign: "left"
            }, idx))
    });
}
function $397c8b1a60686856$export$88277120dd767cf5({ background: background }) {
    const lang = (0, $acw62.useContext)((0, $3S1uf.default));
    const [content, setContent] = (0, $acw62.useState)(null);
    const active = content != null;
    (0, $acw62.useEffect)(()=>{
        fetch(`/api/professor_details/services.${lang}.json`).then((res)=>{
            if (res.ok) return res.json();
            throw new Error(`Fetch /api/professor_details/services.${lang}.json failed`);
        }).then((json)=>setContent(json)).catch((e)=>console.error(e));
    }, [
        lang
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7k9bU.Container), {
        active: active,
        fill: background,
        full: true,
        padding: "all",
        children: content?.map((group, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7k9bU.InfoGroup), {
                active: true,
                title: group.title,
                contents: group.contents.map((c)=>({
                        title: c.title,
                        description: c.description,
                        align: c.title == "" ? "justify" : "center",
                        color: c.title == "" ? "dark" : "light"
                    }))
            }, idx))
    });
}
function $397c8b1a60686856$export$3c0074a3e47084e0({ config: config }) {
    const lang = (0, $acw62.useContext)((0, $3S1uf.default));
    const [tab, setTab] = (0, $acw62.useState)(0);
    const onTabClick = (tabId)=>setTab(tabId);
    const availableTabData = {
        'current_research': [
            'Current Research',
            "\u7814\u7A76\u65B9\u5411"
        ],
        'biography': [
            'Biography',
            "\u81EA\u50B3"
        ],
        'honors': [
            'Honors & Awards',
            "\u69AE\u8B7D\u7D00\u9304"
        ],
        'publications': [
            'Recent Publications',
            "\u8457\u4F5C\u5C08\u5229"
        ],
        'services': [
            'Service',
            "\u7D93\u6B77"
        ]
    };
    let content = config?.contents || [];
    content = content?.filter((d)=>Object.keys(availableTabData).includes(d));
    const tabNames = content?.map((d)=>lang == 'en' ? availableTabData[d][0] : availableTabData[d][1]);
    const tabIdx = content;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($397c8b1a60686856$var$ProfessorDetailTab, {
                tabNames: tabNames,
                currentTab: tab,
                onTabClick: onTabClick
            }),
            tabIdx[tab] == 'current_research' && /*#__PURE__*/ (0, $ayMG0.jsx)($397c8b1a60686856$export$c15df2d8b869fe4d, {
                background: config?.background
            }),
            tabIdx[tab] == 'biography' && /*#__PURE__*/ (0, $ayMG0.jsx)($397c8b1a60686856$export$57ecca8ac58a4530, {
                background: config?.background
            }),
            tabIdx[tab] == 'honors' && /*#__PURE__*/ (0, $ayMG0.jsx)($397c8b1a60686856$export$c98c3d1bc7c1ec35, {
                background: config?.background
            }),
            tabIdx[tab] == 'publications' && /*#__PURE__*/ (0, $ayMG0.jsx)($397c8b1a60686856$export$60832fa9c80d3b5b, {
                background: config?.background
            }),
            tabIdx[tab] == 'services' && /*#__PURE__*/ (0, $ayMG0.jsx)($397c8b1a60686856$export$88277120dd767cf5, {
                background: config?.background
            })
        ]
    });
}

});



//# sourceMappingURL=intro.c6c16525.js.map
